import { useMemo, useState } from "react";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import { Helmet } from "react-helmet-async";
import CustomTab from "../../../components/custom_tab/CustomTab";
import { WorkTimeTabColumns } from "../../../components/custom_tab/tabColumns";
import { useSearchParams } from "react-router-dom";
import OvertimeManagementView from "./views/OvertimeManagementView";
import WorkTimeView from "./views/WorkTimeView";
import useUserStore from "../../../state-management/useUserStore";
import HumanResourceLayout from "../../../components/layouts/HumanResourceLayout";
import { PERMISSIONS, useValidateUserPermissions } from "../../../helpers/usePermissionManager";

const WortTimeAndOvertimeManagement = () => {
	const hasPermission = useValidateUserPermissions([PERMISSIONS.EMPLOYEES_TIME_WRITE]);
	const { userType } = useUserStore();
	const LAYOUT = useMemo(() => {
		switch(userType) {
			case "ORGANIZATION": 
				return PayrollCompanyLayout;
			default: 
				return HumanResourceLayout;
		}
	}, [userType])
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || "workTime"
	);
	
	return (hasPermission && <>
		<LAYOUT>
			<Helmet>
				<title>Work Time |{userType === "HR" ? " HR " : " Company "}Flow</title>
			</Helmet>
			<h1 className="font-bold text-xl mb-8">Work Time</h1>
			<CustomTab
				view={view}
				setView={setView}
				tabColumns={WorkTimeTabColumns}
			>
				{view === "workTime" && <WorkTimeView />}
				{view === "overtimeManagement" && <OvertimeManagementView />}
			</CustomTab>
		</LAYOUT>
	</>);
};

export default WortTimeAndOvertimeManagement;
